var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessmentArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.295,
    height: 10.058,
    viewBox: "0 0 28.295 10.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38335",
    "data-name": "Group 38335",
    transform: "translate(0 1.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_283_1",
    "data-name": "Component 283 \\u2013 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x2: 27.291,
    transform: "translate(0 7.443)",
    fill: "none",
    stroke: "#5586d4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x2: 8.27,
    y2: 7.443,
    transform: "translate(19.021)",
    fill: "none",
    stroke: "#5586d4",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentArrow);
export default __webpack_public_path__ + "static/media/assessmentArrow.bc612f7320e67bf6815fc79cacc5d706.svg";
export { ForwardRef as ReactComponent };